import constants from '@/utils/constants';
import Fetch from '@/utils/Fetch';
import optionService from '@/services/option/option-service';
import helper from '@/utils/helper';

const getJobList = async (searchPhrase: any, pageSize: any, currentPage: any, activeFilterIds: any, ancillaryFilters: any, sortField: any, sortDirection: any, caller = null, toast = null) => {
    const usePopulatedList = false; // make this true when optimisations have been made to the job query
    const checkboxColumnHeader = 'Number';
    const checkboxColumn = 'JobCardNumber';

    let params: Record<string, any> = {
      pageSize,
      pageIndex: currentPage - 1,
      searchPhrase,
      SortExpression:
        sortField === checkboxColumnHeader ? checkboxColumn : sortField,
      SortDirection: sortDirection,
      PopulatedList: usePopulatedList,
    };

    if(activeFilterIds?.DateRange) {
        if(activeFilterIds.DateRange[0]) {
            (params as any).StartDate = activeFilterIds.DateRange[0]
        }
        if(activeFilterIds.DateRange[1]) {
            (params as any).EndDate = activeFilterIds.DateRange[1]
        }
    }

    if (activeFilterIds) {
        params = {...params,
            JobStatusIDList: activeFilterIds["JobStatus"],
            InventoryIDList: activeFilterIds["Services"],
            JobTypeIDList: activeFilterIds["JobTypes"],
            EmployeeIDList: activeFilterIds["Employees"],
            StoreIDList: activeFilterIds["Stores"],
        };
    }

    if (ancillaryFilters) {
        params = {...params,
            IncludeClosed: ancillaryFilters["IncludeClosed"],
            ShowArchived: ancillaryFilters["ShowArchived"],
        };
    }
    
    return await Fetch.post({
        url: '/Job/GetJobs',
        params: params,
        toastCtx: toast,
        caller: caller!,
      });
};

const getJobsForCustomer = async (customerID: any, searchPhrase: any, pageSize: any, pageIndex: any, sortExpression: any, sortDirection: any, includeClosed: any, toast = null, showArchived: any) => {
    let params = {
        pageSize,
        pageIndex,
        searchPhrase,
        sortExpression,
        sortDirection,
        includeClosed,
        CustomerIDList: [customerID],
        showArchived
    };

    return await Fetch.post({
        url: '/Job/GetJobs',
        params,
        toastCtx: toast
    });
};

const getJobsForProject = async (projectID: any, searchPhrase: any, pageSize: any, pageIndex: any, sortExpression: any, sortDirection: any, includeClosed: any, toast = null, showArchived: any) => {
    return await Fetch.post({
        url: '/Job/GetJobsForProject',
        params: {
            pageSize,
            pageIndex,
            searchPhrase,
            sortExpression,
            sortDirection,
            includeClosed,
            projectID,
            showArchived
        },
        toastCtx: toast,
      });
};

const getJobsForAsset = async (productID: any, searchPhrase: any, pageSize: any, pageIndex: any, sortExpression: any, sortDirection: any, includeClosed: any, toast = null, showArchived: any) => {
    let params = {
        pageSize,
        pageIndex,
        searchPhrase,
        sortExpression,
        sortDirection,
        includeClosed,
        productID,
        showArchived
    };

    return await Fetch.post({
        url: '/Job/GetJobsForProduct',
        params,
        toastCtx: toast
    });
};

const getJob = async (id: any) => {
    return await Fetch.get({
        url: '/Job/' + id
    });
}

const getJobCustomerZone = async (id: any, customerID: any, tenantID: any, api: any) => {
    return await Fetch.get({
        url: `/CustomerZone/GetJob`,
        params: {
            jobCardID: id
        },
        tenantID: tenantID,
        customerID: customerID,
        apiUrlOverride: api,
    });
};

const updateJobCustomerZone = async (customerID: any, tenantID: any, api: any, job: any, toast = null) => {
    return await Fetch.put({
        url: '/CustomerZone/UpdateJob',
        params: {
          Job: job
        },
        toastCtx: toast,
        tenantID: tenantID,
        customerID: customerID,
        apiUrlOverride: api,
    });
};

const getMarkAsUsedOnClosedOptionValue = async () => {
    let value = await optionService.getOptionValue(constants.optionKeys.JobCardPreferenceClosedMarksMaterialsAsUsed);
    return helper.parseBool(value);
}

const getEffectiveWarehouse = async (jobCardID: any) => {
    return await Fetch.get({
        url: `/Job/EffectiveWarehouse`,
        params: {
            jobCardID
        }
    });
}

export default {
    getJob,
    getJobCustomerZone,
    updateJobCustomerZone,
    getJobList,  
    getJobsForAsset,
    getJobsForCustomer,
    getJobsForProject,
    getMarkAsUsedOnClosedOptionValue,
    getEffectiveWarehouse
};
